import React, { Component } from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import config from '../../data/SiteConfig'
import Typewriter from '../components/UI/typewriter'
import { typeWriterArray } from '../../data/customersContent'
import commercialLogos from '../assets/commercial_logos/assets'
import higherEdLogos from '../assets/highered_logos/exports'
import publicLogos from '../assets/public_sector_logos/exports'
import { FaHeart } from 'react-icons/lib/fa'

const iconStyle = {
  width: '40px',
  height: '40px',
  color: '#ea2e53',
  marginLeft: '10px'
}

class CustomersPage extends Component {
  buildLogoGrid(logos) {
    const logoElements = []
    for (var key in logos) {
      logoElements.push(
        <div className="logo">
          <img src={logos[key]} />
        </div>
      )
    }
    return logoElements
  }

  render() {
    return (
      <div className="customers-container">
        <Helmet title={`Customers | ${config.siteTitle}`} />
        <CustomersPageContainer>
          <h1>World class teams use AppTree's platform.</h1>
          <section>
            <h2>Commercial</h2>
            <CommercialGrid>
              {this.buildLogoGrid(commercialLogos)}
            </CommercialGrid>
          </section>
          <section>
            <h2>Higher Education</h2>
            <CommercialGrid>{this.buildLogoGrid(higherEdLogos)}</CommercialGrid>
          </section>
          <section>
            <h2>Public Sector</h2>
            <CommercialGrid>{this.buildLogoGrid(publicLogos)}</CommercialGrid>
          </section>
          {/*<div className="message">*/}
          {/*<h4>We love you.</h4>*/}
          {/*<FaHeart style={iconStyle} />*/}
          {/*</div>*/}

          {/*<div className="sign-off">*/}
          {/*<h3>Sincerly,</h3>*/}
          {/*<h3>AppTree</h3>*/}
          {/*</div>*/}
        </CustomersPageContainer>
      </div>
    )
  }
}

const CustomersPageContainer = styled.div`
  width: 100vw;
  padding: 100px;
  & section {
    margin: 50px 0;
  }
  & section h2 {
    border-bottom: 1px solid black;
  }

  .sign-off {
    margin: 25px;
  }

  .message {
    display: flex;
    align-items: center;
  }
`

const CommercialGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 150px);
  grid-gap: 10px;
  justify-content: center;

  .logo {
    height: 150px;
    width: 150px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .logo > img {
    max-width: 130px;
    max-height: 130px;
    margin: auto;
  }
`

export default CustomersPage



// WEBPACK FOOTER //
// ./src/pages/customers.jsx